export async function load({ url }) {
	return {
		pathname: url.pathname
	};
}
